// extracted by mini-css-extract-plugin
export default {"submitImage":"xza9Ws","trackingPixel":"PcKrIU"};